// import { BASE_URL } from "../api/providerApi";

// // Load reCAPTCHA v3 script dynamically
// export const loadRecaptcha = () => {
//     return new Promise((resolve, reject) => {
//         if (window.grecaptcha) {
//             resolve();
//             return;
//         }

//         const script = document.createElement('script');
//         script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_RECAPTCHA_SITE_KEY}`;
//         script.async = true;
//         script.defer = true;

//         script.onload = () => resolve();
//         script.onerror = () => reject('Failed to load reCAPTCHA');

//         document.body.appendChild(script);
//     });
// };

// // Get a reCAPTCHA token (v3)
// export const getCaptchaToken = () => {
//     return new Promise((resolve, reject) => {
//         if (!window.grecaptcha) {
//             reject('reCAPTCHA not loaded');
//             return;
//         }

//         window.grecaptcha.ready(() => {
//             window.grecaptcha
//                 .execute(process.env.REACT_APP_RECAPTCHA_SITE_KEY, { action: 'getToken' })
//                 .then(resolve)
//                 .catch(reject);
//         });
//     });
// };

// // Call your getToken API with reCAPTCHA token
// export const getTokenAPI = async () => {
//     try {
//         // 1️⃣ Load reCAPTCHA script
//         await loadRecaptcha();

//         // 2️⃣ Generate token
//         const recaptchaToken = await getCaptchaToken();
//         // 3️⃣ Call API using fetch
//         const response = await fetch(`${BASE_URL}/providerempanelment/getToken`, {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json',
//                 accept: '*/*',
//             },
//             body: JSON.stringify({
//                 clientId: process.env.REACT_APP_CLIENT_ID,
//                 clientSecret: process.env.REACT_APP_CLIENT_SECRET,
//                 echoToken: recaptchaToken,
//             }),
//         });

//         if (!response.ok) {
//             throw new Error('Failed to get API token');
//         }

//         const result = await response.json();
//         return result;
//     } catch (err) {
//         console.error('Error in getTokenAPI:', err);
//         throw err;
//     }
// };



// export const toAmPm = (time24) => {
//     if (!time24) return '';
//     let [hours, minutes] = time24.split(':').map(Number);

//     const ampm = hours >= 12 ? 'PM' : 'AM';
//     hours = hours % 12 || 12;

//     return `${hours}:${minutes.toString().padStart(2, '0')} ${ampm}`;
// };

// export const to24Hour = (time, ampm) => {
//     let [hours, minutes] = time.split(':').map(Number);
//     if (ampm === 'PM' && hours !== 12) hours += 12;
//     if (ampm === 'AM' && hours === 12) hours = 0;
//     return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
// };





import { BASE_URL } from "../api/providerApi";

let recaptchaLoadingPromise = null;
let recaptchaLoadFailed = false;

// Load reCAPTCHA v3 script dynamically
export const loadRecaptcha = () => {
    // If already loaded successfully
    if (window.grecaptcha) {
        return Promise.resolve();
    }

    // If currently loading, return the existing promise
    if (recaptchaLoadingPromise) {
        return recaptchaLoadingPromise;
    }

    // If previously failed, retry
    if (recaptchaLoadFailed) {
        recaptchaLoadFailed = false;
        recaptchaLoadingPromise = null;
    }

    recaptchaLoadingPromise = new Promise((resolve, reject) => {
        const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

        if (!siteKey) {
            const error = new Error('reCAPTCHA site key not configured');
            recaptchaLoadFailed = true;
            recaptchaLoadingPromise = null;
            reject(error);
            return;
        }

        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
        script.async = true;
        script.defer = true;

        script.onload = () => {
            recaptchaLoadingPromise = null;
            resolve();
        };

        script.onerror = () => {
            recaptchaLoadFailed = true;
            recaptchaLoadingPromise = null;

            // Remove the failed script tag
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }

            reject(new Error('Failed to load reCAPTCHA script'));
        };

        document.body.appendChild(script);
    });

    return recaptchaLoadingPromise;
};

// Get a reCAPTCHA token (v3)
export const getCaptchaToken = (action = 'getToken') => {
    return new Promise((resolve, reject) => {
        if (!window.grecaptcha) {
            reject(new Error('reCAPTCHA not loaded'));
            return;
        }

        const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

        if (!siteKey) {
            reject(new Error('reCAPTCHA site key not configured'));
            return;
        }

        window.grecaptcha.ready(() => {
            window.grecaptcha
                .execute(siteKey, { action })
                .then(resolve)
                .catch((err) => {
                    reject(new Error(`reCAPTCHA execution failed: ${err.message}`));
                });
        });
    });
};

// Call your getToken API with reCAPTCHA token
export const getTokenAPI = async (options = {}) => {
    const { skipRecaptcha = false, retryOnRecaptchaFail = true } = options;

    try {
        let recaptchaToken = null;

        if (!skipRecaptcha) {
            try {
                // 1️⃣ Load reCAPTCHA script
                await loadRecaptcha();

                // 2️⃣ Generate token
                recaptchaToken = await getCaptchaToken();
            } catch (recaptchaError) {
                console.error('reCAPTCHA error:', recaptchaError);

                // Option 1: Proceed without reCAPTCHA (if backend allows)
                if (retryOnRecaptchaFail) {
                    console.warn('Proceeding without reCAPTCHA token');
                    recaptchaToken = null;
                } else {
                    // Option 2: Fail the entire request
                    throw new Error(`reCAPTCHA failed: ${recaptchaError.message}`);
                }
            }
        }

        // 3️⃣ Call API using fetch
        const response = await fetch(`${BASE_URL}/providerempanelment/getToken`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                accept: '*/*',
            },
            body: JSON.stringify({
                clientId: process.env.REACT_APP_CLIENT_ID,
                clientSecret: process.env.REACT_APP_CLIENT_SECRET,
                ...(recaptchaToken && { echoToken: recaptchaToken }),
            }),
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.message || `API error: ${response.status}`);
        }

        const result = await response.json();
        return result;

    } catch (err) {
        console.error('Error in getTokenAPI:', err);
        throw err;
    }
};

// Utility to manually retry loading reCAPTCHA
export const retryLoadRecaptcha = () => {
    recaptchaLoadFailed = false;
    recaptchaLoadingPromise = null;
    return loadRecaptcha();
};

// Time conversion utilities (with validation)
export const toAmPm = (time24) => {
    if (!time24 || typeof time24 !== 'string') return '';

    const parts = time24.split(':');
    if (parts.length < 2) return '';

    let [hours, minutes] = parts.map(Number);

    if (isNaN(hours) || isNaN(minutes) || hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
        return '';
    }

    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;

    return `${hours}:${minutes.toString().padStart(2, '0')} ${ampm}`;
};

export const to24Hour = (time, ampm) => {
    if (!time || !ampm) return '';

    const parts = time.split(':');
    if (parts.length < 2) return '';

    let [hours, minutes] = parts.map(Number);

    if (isNaN(hours) || isNaN(minutes)) return '';

    if (ampm === 'PM' && hours !== 12) hours += 12;
    if (ampm === 'AM' && hours === 12) hours = 0;

    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
};